import { useState } from "react";
import { useMutation, useQuery,useQueryClient } from "@tanstack/react-query";
import { fetchProperties, countByStatus, searchProperty, updateProperty, deleteProperty, addProperty } from "../api/propertyApi";
import toast from 'react-hot-toast'

export const useProperties = () => {
    const [searchResults, setSearchResults] = useState(null);
    const [propertyId, setPropertId] = useState(null);
    const queryClient = useQueryClient();

    const { data: properties, error, isLoading } = useQuery({
        queryKey: ['properties'],
        queryFn: fetchProperties,
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Failed to fetch properties ��')
        }
    })

    const { data: countByStatusData, error: countByStatusError, isLoading: countByStatusLoading } = useQuery({
        queryKey: ['countByStatus'],
        queryFn: countByStatus,
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Failed to fetch count by status')
        }
    })

    const searchPropertyNumberMutation = useMutation({
        mutationFn: searchProperty,
        onSuccess: (data) => {
            toast.success(data.message || 'Property found successfully!');
            setSearchResults(data);
            queryClient.invalidateQueries(['properties']);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Failed to search property')
        }
    })

    const updatePropertyMutation = useMutation({
        mutationFn: updateProperty,
        onSuccess: (data)=>{
            toast.success(data.message || "Property updated successfully");
            queryClient.invalidateQueries(['properties'])
        },
        onError: (error) => {
            toast.error(error.response?.data?.error || error.response?.data?.message || 'Failed to update property')
        }
    })

    const deletePropertyMutation = useMutation({
        mutationFn: deleteProperty,
        onSuccess: (data) =>{
            toast.success(data.message || "Property delete successfully");
            queryClient.invalidateQueries(['properties'])
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Failed to delete property')
        }
    })

    const addPropertyMutation = useMutation({
        mutationFn: addProperty,
        onSuccess: (data) =>{
            toast.success(data.message || "Property created successfully");
            queryClient.invalidateQueries(['properties'])
            setPropertId(data.propertyId)
        },
        onError: (error) => {
            // Match the update mutation: the backend returns { error } (plus { details } for
            // Joi failures), so reading only .message swallowed e.g. duplicate-MLS# errors.
            const data = error.response?.data
            toast.error(
                data?.error ||
                (Array.isArray(data?.details) ? data.details.join(', ') : null) ||
                data?.message ||
                'Failed to create property'
            )
        }
    })

    return { 
        properties,
        isLoading,
        error,
        countByStatusData,
        countByStatusLoading,
        countByStatusError,
        searchPropertyNumber:searchPropertyNumberMutation.mutate,
        searchPropertyNumberLoading: searchPropertyNumberMutation.isPending,
        searchResults,
        propertyUpdate:updatePropertyMutation.mutate,
        propertyUpdateLoading:updatePropertyMutation.isPending,
        propertyUpdateSuccess: updatePropertyMutation.isSuccess,
        propertyDelete:deletePropertyMutation.mutate,
        propertyDeleteLoading:deletePropertyMutation.isPending,
        propertyDeleteSuccess:deletePropertyMutation.isSuccess,
        propertyAdd:addPropertyMutation.mutate,
        propertyAddLoading:addPropertyMutation.isPending,
        propertyAddSuccess:addPropertyMutation.isSuccess,
        propertyId
     }
}